
//https://stackoverflow.com/questions/25562173/calculate-number-of-specific-weekdays-between-dates
export default function( days, d0, d1 ) {
    var ndays = 1 + Math.round((d1-d0)/(24*3600*1000));
    var sum = function(a,b) {
        return a + Math.floor( ( ndays + (d0.getDay()+6-b) % 7 ) / 7 ); 
    };
  return days.reduce(sum,0);
}
